import gql from 'graphql-tag';

const CreateDeliveryEvent = gql(/* GraphQL */ `
  mutation CreateDeliveryEvent($input: CreateDeliveryEventInput!) {
    createDeliveryEvent(input: $input) {
      driverAssignment {
        id
        delivery {
          id
          status
        }
      }
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default CreateDeliveryEvent;
